export default "__VITE_ASSET__D62yok_g__"